<ftr-form-input
  name="password"
  [type]="type"
  [label]="label"
  [autofocus]="autofocus"
  [ngFormControl]="ngFormControl"
  [required]="true"
  [highlightError]="highlightError"
  [notrack]="true"
  [hideValidationErrors]="hideValidationErrors"
  [autocomplete]="autocomplete"
/>
<button
  type="button"
  (click)="toggleVisibility()"
  class="password__visibility"
  [ngClass]="{
    'password__visibility--hidden': type === 'password',
    'password__visibility--visible': type === 'text',
  }"
>
  <svg
    class="password__make-visible align-bottom"
    ftrIcon="VisibilityOn"
    label="Make password visible"
    [iconSize]="24"
  ></svg>
  <svg
    class="password__make-invisible align-bottom"
    ftrIcon="VisibilityOff"
    label="Make password invisible"
    [iconSize]="24"
  ></svg>
</button>
